module.exports = __webpack_public_path__ + "static/media/unix.74718e26.svg";